import React, { FC, useState, MouseEvent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { TableRow, TableCell } from '@mui/material';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import * as SofiFormInteractors from '../../redux/interactors/SofiFormInteractors';

interface StateProps {
  name: string;
  tag: string;
  valueRange: number[];
}

interface DispatchProps {
  updateInteractor: typeof SofiFormInteractors.updateInteractor;
}

interface Props extends StateProps, DispatchProps {
  // extra props you want to add
}

const pickHex = (color1: number[], color2: number[], weight: number) => {
  const w1 = weight;
  const w2 = 1 - w1;
  const rgb = [
    Math.round(+color1[0] * w1 + +color2[0] * w2),
    Math.round(+color1[1] * w1 + +color2[1] * w2),
    Math.round(+color1[2] * w1 + +color2[2] * w2),
  ];
  return `rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]})`;
};

export const SofiTableRow2: FC<Props> = (props: Props) => {
  const [selectedValue, setSelectedValue] = useState<number | null>(null);
  const [label, setLabel] = useState('');
  const { valueRange, name } = props;

  const handleChange = (event: MouseEvent<HTMLElement>, newValue: number) => {
    setSelectedValue(newValue);
    props.updateInteractor({ name: props.name, value: newValue });
    if (newValue <= 3) {
      setLabel('BAJO');
    } else if (newValue <= 6) {
      setLabel('MEDIO');
    } else {
      setLabel('ALTO');
    }
  };
  return (
    <>
      <TableRow sx={{ marginY: '0px', paddingY: '0px', marginX: '0px', paddingX: '0px' }}>
        <TableCell colSpan={2} sx={{ fontSize: 'medium', borderBottom: 'none', margin: '0px', padding: '0px' }}>
          <p>
            <b>{props.tag}:</b> {label}
          </p>
        </TableCell>
      </TableRow>
      <TableRow sx={{ marginY: '0px', paddingY: '0px', marginX: '0px', paddingX: '0px' }}>
        <TableCell colSpan={2} sx={{ borderBottom: 'none', margin: '0px', padding: '0px' }}>
          <ToggleButtonGroup
            color="primary"
            value={selectedValue}
            exclusive
            onChange={handleChange}
            aria-label="Platform">
            {valueRange.map((v, i) => (
              <ToggleButton
                key={`${name}-cell-${v}`}
                value={v}
                sx={{
                  margin: '0',
                  color:
                    i * 2 > valueRange.length
                      ? pickHex([255, 0, 0], [255, 255, 0], +(i - 5) / 5)
                      : pickHex([255, 255, 0], [0, 255, 0], +i / 5),
                  fontWeight: 'bold',
                  height: '30px',
                  width: '30px',
                  '&.MuiToggleButton-standard': {
                    borderRadius: '100px',
                    height: '30px',
                    width: '30px',
                    margin: '0',
                  },
                  '&.Mui-selected, &.Mui-selected:hover': {
                    borderRadius: '100px',
                    height: '30px',
                    width: '30px',
                    background:
                      i * 2 > valueRange.length
                        ? pickHex([255, 0, 0], [255, 255, 0], +(i - 5) / 5)
                        : pickHex([255, 255, 0], [0, 255, 0], +i / 5),
                    color: 'white',
                    fontWeight: 'bold',
                    margin: '0',
                  },
                  '&.MuiToggleButtonGroup-grouped': {
                    borderRadius: '100px !important',
                    mx: 1,
                    border: 'none',
                    marginY: '0',
                    marginX: '-4px',
                  },
                }}>
                {v}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        </TableCell>
      </TableRow>
      <TableRow sx={{ marginY: '0px', paddingY: '0px', marginX: '0px', paddingX: '0px' }}>
        <TableCell sx={{ color: '#bbb', fontWeight: 'bold', margin: '0px', padding: '0px' }}>
          {'< BAJO grado'}
        </TableCell>
        <TableCell sx={{ color: '#bbb', fontWeight: 'bold', margin: '0px', padding: '0px' }}>
          {'ALTO grado >'}
        </TableCell>
      </TableRow>
    </>
  );
};

const mapDispatchToProps = (dispatch: any): DispatchProps => ({
  ...bindActionCreators(
    {
      ...SofiFormInteractors,
    },
    dispatch,
  ),
});

export default connect(null, mapDispatchToProps)(SofiTableRow2);
